import ReactGA from "react-ga4";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import Navigation from "./components/Navigation";
// import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import Reservations from "./components/3DPr";
import About from "./components/About";
import Contact from "./components/Contact";
import Events from "./components/Events";
import Footer from "./components/Footer";
import Hardware from "./components/Hardware";
import Home from "./components/Home";
import Gitcourse from "./components/Interactive Minicourse/Gitcourse";
import TerminalCourse from "./components/Interactive Minicourse/TerminalCourse";
import JoinUs from "./components/join-us";
import Schedule from "./components/LabSchedule";
import Minicourses from "./components/Minicourses";
import Policies from "./components/Policies";
import SeatVisualization from "./components/SeatVisualization";
import Software from "./components/Software";
import Staff from "./components/Staff";
import Visit from "./components/Visit";
import Assistant from "./components/Assistant";

function App() {
  ReactGA.initialize("G-4V51Q52L4Z");
  return (
    <div className="App">
      <Router>
        <Navigation />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/joinus">
            <JoinUs />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/software">
            <Software />
          </Route>
          <Route path="/hardware">
            <Hardware />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="/visit">
            <Visit />
          </Route>
          <Route path="/events">
            <Events />
          </Route>
          <Route path="/staff">
            <Staff />
          </Route>
          <Route path="/minicourses">
            <Minicourses />
          </Route>
          <Route path="/reservations">
            <Reservations />
          </Route>
          <Route path="/labschedule">
            <Schedule />
          </Route>
          <Route path="/policies">
            <Policies />
          </Route>
          <Route path="/gitcourse">
            <Gitcourse />
          </Route>
          <Route path="/terminalcourse">
            <TerminalCourse />
          </Route>
          <Route path="/seats">
            <SeatVisualization />
          </Route>
          <Route path="/assistant">
            <Assistant />
          </Route>
        </Switch>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
